import styled from 'styled-components';
import { Cell, FlexContainer } from '@taxdown/piccolo-web';
import { pxToRem } from 'Styles/utils/utils';

export const Info = styled(FlexContainer)`
  display: flex;
  justify-content: space-between;
  padding: 15px 17px 15px 15px;
  border-radius: 14px;
  background: ${({ theme: { colors } }) => colors.green_7};
`;

export const Image = styled.img`
  width: ${pxToRem(155.95)};
  height: ${pxToRem(123.28)};
`;

export const ListItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 25px;
  margin-bottom: 28px;
  padding: 0px;
  gap: 10px;
  width: 100%;
  height: 20px;
  svg {
    width: 12px;
  }
`;

export const InfoContent = styled(Cell)`
  div {
    border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_L};
    padding: ${({ theme: { system } }) => system.fds_sys_spacing_S};
  }
`;
